import {
  FETCH_ADS,
  FETCH_AD_DETAILS,
  FETCH_ADS_SUMMARY,
  SET_AD_STATUS,
  FETCH_AD_PRODUCTS,
  SET_MULTIPLE_ADS_STATUS,
} from './actionTypes';
import parseError from 'utils/parseError';
import { mapKeys } from 'lodash';

const INITIAL_STATE = {
  products: [],
  summary: [],
  data: {},
  meta: {},
  fetching: false,
  editing: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ADS.pending:
    case FETCH_AD_DETAILS.pending:
    case FETCH_ADS_SUMMARY.pending:
    case FETCH_AD_PRODUCTS.pending:
      return {
        ...state,
        fetching: true,
        error: null,
      };

    case FETCH_ADS.rejected:
    case FETCH_AD_DETAILS.rejected:
    case FETCH_ADS_SUMMARY.rejected:
    case FETCH_AD_PRODUCTS.rejected:
      return {
        ...state,
        fetching: false,
        error: parseError(action.payload),
      };

    case FETCH_ADS.fulfilled:
      return {
        ...state,
        fetching: false,
        data: mapKeys(action.payload.data.data, 'id'),
        meta: action.payload.data.meta,
      };

    case FETCH_AD_DETAILS.fulfilled:
      return {
        ...state,
        fetching: false,
        data: {
          ...state.data,
          [action.payload.data.id]: action.payload.data,
        },
      };

    case FETCH_ADS_SUMMARY.fulfilled:
      return {
        ...state,
        fetching: false,
        summary: action.payload.map((res) => res.data),
      };

    case FETCH_AD_PRODUCTS.fulfilled:
      return {
        ...state,
        fetching: false,
        products: action.payload.data,
      };

    case SET_AD_STATUS.pending:
    case SET_MULTIPLE_ADS_STATUS.pending:
      return {
        ...state,
        editing: true,
      };

    case SET_AD_STATUS.rejected:
    case SET_MULTIPLE_ADS_STATUS.rejected:
      return {
        ...state,
        editing: false,
      };

    case SET_AD_STATUS.fulfilled:
    case SET_MULTIPLE_ADS_STATUS.fulfilled:
      return {
        ...state,
        editing: false,
      };

    default:
      return state;
  }
};
